module.exports = __webpack_public_path__ + "img/patriots.6de86a48.jpg";